module.exports = __webpack_public_path__ + "img/gas-pump-light.8f1165bd.svg";